// The 2026-10-03 ledger reports keep their strings in one file pair per
// report, so seven pages can be built in parallel without editing the same
// locale file. This index merges them ONCE (in src/i18n.js) under
// finance.reports2.<camelCaseSlug>.
import common_ar from "./common.ar";
import common_en from "./common.en";
import generalJournalSummary_ar from "./general-journal-summary.ar";
import generalJournalSummary_en from "./general-journal-summary.en";
import driverStatement_ar from "./driver-statement.ar";
import driverStatement_en from "./driver-statement.en";
import cashFlowStatement_ar from "./cash-flow-statement.ar";
import cashFlowStatement_en from "./cash-flow-statement.en";
import equityChanges_ar from "./equity-changes.ar";
import equityChanges_en from "./equity-changes.en";
import accountStatement_ar from "./account-statement.ar";
import accountStatement_en from "./account-statement.en";
import accountingBalance_ar from "./accounting-balance.ar";
import accountingBalance_en from "./accounting-balance.en";
import accountsInventory_ar from "./accounts-inventory.ar";
import accountsInventory_en from "./accounts-inventory.en";

export default {
  ar: {
    common: common_ar,
    generalJournalSummary: generalJournalSummary_ar,
    driverStatement: driverStatement_ar,
    cashFlowStatement: cashFlowStatement_ar,
    equityChanges: equityChanges_ar,
    accountStatement: accountStatement_ar,
    accountingBalance: accountingBalance_ar,
    accountsInventory: accountsInventory_ar,
  },
  en: {
    common: common_en,
    generalJournalSummary: generalJournalSummary_en,
    driverStatement: driverStatement_en,
    cashFlowStatement: cashFlowStatement_en,
    equityChanges: equityChanges_en,
    accountStatement: accountStatement_en,
    accountingBalance: accountingBalance_en,
    accountsInventory: accountsInventory_en,
  },
};

/** messages + { finance: { ...messages.finance, reports2 } } without mutating the imports. */
export function withFinanceReports2(messages, reports2) {
  return Object.assign({}, messages, {
    finance: Object.assign({}, messages.finance, { reports2: reports2 }),
  });
}
